




























import { Component, Mixins } from 'vue-property-decorator';
import { LogoutConfirmation, UserLogged } from '../components';
import { clearLocalStorage, EventBus, isProductionMode, PRIVILEGE_KEYS, PRIVILEGE_TYPES, TypeEventBus } from '../utils';
import { UserService } from '../api';
import { AuthStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../mixins';
import ModalUserPreferences from '../../user/components/ModalUserPreferences.vue';
import { UserList } from '../../user/models/Users';
import { getSavedCredentials } from '../../user/helpers';
import OpenChatbotButton from '../../chatbot/components/OpenChatbotButton.vue';

const RETURN_BECAUSE_MENU = '2';
const DOMAIN = '.smartwaypanel.com';

@Component({
    components: {
        LogoutConfirmation, 
        UserLogged, 
        ModalUserPreferences,
        OpenChatbotButton
    }
})
export default class ToolBar extends Mixins(RootStoreHelper, AuthStoreHelper, NotificationStoreHelper) {
    openConfirmation: boolean = false;
    progressHeight: number = 4;
    visibleChangePassword: boolean = false;
    userInfo: UserList | null = null;

    mounted(){
         EventBus.$on(TypeEventBus.SHOW_USER_PREFERENCES, () => {
            this.showUserPreferencesModal();
        });
    }

     get shouldSeeChatbot(): boolean {
         return (
            this.$_checkPrivileges(PRIVILEGE_KEYS.SMARTCHAT, PRIVILEGE_TYPES.READ)
        );
    }


    showUserPreferencesModal(){
        let info = getSavedCredentials();
        this.userInfo = {
            id: info && info.id  || 0,
            email: info && info.email || '',
            username: info && info.username || ''
        }
        this.visibleChangePassword = true;
    }

    closeUserPreferences(){
        this.userInfo = null;
        this.visibleChangePassword = false;
    }

    handleLogout(): void {
        this.openConfirmation = true;
    }

    handleRedirect(): void {
        if (isProductionMode()) {
            let location: string = process.env.VUE_APP_LOGIN_REDIRECT as string;

            // window.location.href = location;
            //Abrir en una nueva pestaña, probar en produccion, en caso de fallo descomentar la linea de arriba y comentar la de abajo
            window.open(location, '_blank');
        }
    }

    handleRedirectToAdmin(): void {
        let link = process.env.VUE_APP_ADMIN
        window.open(link, '_blank');
    }

    closeConfirmation(value): void {
        this.openConfirmation = false;
        if (value) {
            clearLocalStorage();
            this.$_closeSession();
        }
    }

    handleRoute(routeName: string): void {
        this.$router.push({ name: routeName });
    }

    handleSetting() {
        // console.log('HandleSetting settings');
    }

    handleStartTour(): void {
        UserService.tourState(false)
            .then(() => {
                this.$_setTour(false);
                this.$_setMock(true);
                location.reload();
            })
            .catch(error => {
                if (error['message']) {
                    // this.$_errorToolbar(error['message']);
                } else {
                    this.$_errorToolbar('Error terminando el tour');
                }
            });
    }
}
